import { Legacyprofile as LegacyprofileData} from '@/payload-types'
import { createProfileDetails } from '@/lib/profileFunction'
import LegacyProfileCardComponent from './profileCard'

interface IProps {
  profileData: (string | null) | LegacyprofileData 
}

export const LegacyRegularPostProfileCard = ({ profileData }: IProps) => {
  const arrayOfData = createProfileDetails(profileData)
  return (
    <div className="my-[20px] bg-gray-50 rounded-md default-border shadow-cards p-[12px] w-[254px] ml-2.5 md:w-auto md:ml-0 md:flex">
      <LegacyProfileCardComponent
        profileData={profileData}
        profilePicture={{
          pictureDivCSS: 'h-48 md:h-44 md:w-44 md:mr-[12px]',
          pictureCSS: 'rounded-md default-border',
        }}
        profileFullName={{
          fullNameDivCSS: 'mb-0.5 mt-3 md:mt-0',
          fullNameCSS: 'font-bold text-lg leading-[27px]',
        }}
        moreDetails={{ ifShow: true, ifFlex: true, value: arrayOfData }}
        profileDescription={{
          ifShow: true,
          descCSS: 'text-sm text-gray-600 line-clamp-5 md:line-clamp-3 leading-[21px]',
        }}
        seeProfileBtn={{ ifShow: true, btnCSS: 'mt-2' }}
        showMoreDetails={false}
      />
    </div>
  )
}

export default LegacyRegularPostProfileCard
